export default {
    name: 'login',
    data() {
        return {
            windowHeight: 0,
            routerHeigth: 0,
            errorTip: false,
            checked: false,
            clickMenuNum: 0,
            tipStatus: "",
            tipText: "",
            alertShow: false,
			isRouterAlive: true,
            mainHeights:'',
			isMenusHidden:false,
			curRoute:"",
			sonShowList:[],
			userInfo:{
				username:""
			}
        }
    },
	provide () {
		return {
		  handleRefresh: this.handleRefresh
		}
	},
    created() {
		const userInfo = localStorage.getItem("userInfo")
		if(userInfo){
			this.userInfo = JSON.parse(userInfo)
		}
        this.windowHeight = document.documentElement.clientHeight;
    },
	watch: {
		menus: {
			handler(val, old) {
				const url = this.$route.path
				const routerList = val
				if (Array.isArray(routerList) && routerList.length) {
					const arr = routerList.filter(rL => rL.son && rL.son.filter(s => {
						if(`${s.url}` == url){
							this.curRoute = s.id
							return true
						}else{
							return false
						}
					}).length)
					if (arr.length) {
						this.clickMenuNum = arr[0].id
					}else{
						this.curRoute = ""
						this.clickMenuNum = ""
					}
				}
			},
			deep: true, // 深度监听
			immediate: true, //立即执行
		},
		$route(val){
			if(localStorage.getItem("access_token") && val.fullPath != "/"){
				sessionStorage.setItem("historyRoute",val.fullPath)
			}
			const url = val.path
			const routerList = this.menus
			if (Array.isArray(routerList) && routerList.length) {
				const arr = routerList.filter(rL => rL.son && rL.son.filter(s => {
					if(`${s.url}` == url){
						this.curRoute = s.id
						return true
					}else{
						return false
					}
				}).length)
				if (arr.length) {
					this.clickMenuNum = arr[0].id
				}else{
					this.curRoute = ""
					this.clickMenuNum = ""
				}
			}
		},
		
	},
	computed:{
		menus(){
			return this.$store.state.menus
		}
	},
    mounted() {

        this.mainHeights = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
            window.onresize = () => {
				return (() => {
					this.mainHeights = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight);
				})();
			};
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

        this.routerHeigth = document.documentElement.clientHeight - this.$refs.heardHg.offsetHeight;
    },
    methods: {
		updateMenuNum(num) {
			
			
		},
		handleRefresh() {
			this.isRouterAlive = false; //先关闭，
			this.$nextTick(function () {
				this.isRouterAlive = true; //再打开
			});
		},
        confirmDialog() {
            this.alertShow = false;
            if (this.$store.state.isLogin) {
                this.$store.dispatch('exit', false).then(() => {
                    this.$router.push('/');
                });
            }
        },
        closeDialog() {
            this.alertShow = false;

            //把绑定的弹窗数组 设为false即可关闭弹窗
        },
        exitLogin() {
            this.alertShow = true;
            this.tipStatus = "退出登錄";
            this.tipText = "確定退出登錄";
        },
        clickMenu(num) {
			if(this.clickMenuNum == num){
				this.clickMenuNum = "";
				sessionStorage.removeItem('clickMenu')
			}else{
				this.clickMenuNum = num;
				sessionStorage.setItem("clickMenu", num)
			}
			
			sessionStorage.removeItem('goods_id')
			sessionStorage.removeItem('report_id')
        },
		selectCurRoute(id){
			this.curRoute = id 
			sessionStorage.removeItem("report_id")
		}
    },

    beforeRouteLeave(to, form, next) {
        sessionStorage.clear();
        next()
    }
}
